export function nFormatter(num, digits) {
  return num.toLocaleString();
}

export const ONE_BILLION = 1000000000


// WEBPACK FOOTER //
// src/pages/Raroc/utils.js